import { Injectable } from '@angular/core';
import { Globals } from 'projects/core/src/globals';
import { WSService } from 'projects/core/src/include/service';
import { Observable } from 'rxjs';
import { DossierField, DossierPhase } from '../dossier';

@Injectable({
  providedIn: 'root'
})
export class DossierPhasesService extends WSService<DossierPhase> {

  constructor() { super("dossierphases");}

  /**
   * Restituisce i campi che devono essere mostrati in lista
   * @param id_type Tipologia del dossier su cui effettuare la ricerca
   * @returns 
   */
  getFieldsToShow(id_type:number):Observable<DossierField[]>{
    return Globals.ws.requestUrl("dossierphases","getFieldsToShow",[id_type]);
  }

  /**
   * Restituisce la struttura del dossier in base alla tipologia
   * @param $id_type 
   * @returns 
   */
  getPhasesByType($id_type:number):Observable<DossierPhase[]>{
    return Globals.ws.requestUrl("dossierphases","getPhasesByType",[$id_type]);
  }

  /**
   * Verifica se i nomi dei campi sono già stati usati o meno
   * @param names Array con i nomi dei campi
   * @param id_type Tipologia del dossier su cui effettuare la ricerca
   * @param id_phase ID della fase 
   * @returns elenco dei campi trovati
   */
  checkDuplicateNameField(names:string[],id_type:number,id_phase:number,oncomplete:any){
     Globals.ws.send("dossierphases","checkDuplicateNameField",{"names":names,"id_type":id_type,"id_phase":id_phase},[],oncomplete);
  }

}
